import {Helmet} from 'react-helmet-async';
import {Link,Navigate,useParams} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ESYOHWidgets from './ESYOHWidgets';

const {FiArrowLeft,FiBookOpen,FiCheck,FiClock,FiChevronRight}=FiIcons;

function ModuleView({domains,completedLessons,onToggleLesson}) {
  const {moduleId,slug}=useParams();
  const activeModuleId=moduleId || slug;
  const module=domains.find((item)=> item.id===activeModuleId);

  if (!module) {
    return <Navigate to="/" replace />;
  }

  const completedCount=module.lessons.filter((lesson)=> (
    completedLessons.includes(lesson.id)
  )).length;

  const moduleProgress=Math.round(
    (completedCount / module.lessons.length) * 100,
  );

  return (
    <>
      <style>
        {` .study-lesson-link {margin-right: 18px;color: #0f766e;font-weight: 800;text-decoration: underline;text-underline-offset: 3px;transition: color 0.2s ease,transform 0.2s ease;} .study-lesson-link:hover {color: #082f49;transform: translateX(2px);} @media (max-width: 680px) {.lesson-card {grid-template-columns: auto minmax(0,1fr);align-items: start;} .lesson-content {min-width: 0;text-align: left;} .lesson-actions {width: 100%;grid-column: 1 / -1;display: flex;flex-direction: column;align-items: stretch;gap: 18px;margin-top: 4px;} .study-lesson-link {align-self: flex-start;margin-right: 0;} .lesson-actions .complete-button {width: 100%;}} `}
      </style>

      <Helmet>
        <title>{module.title} | Medical Coding Classes Online</title>
        <meta name="description" content={module.description} />
      </Helmet>

      <main className="module-page">
        <section className="module-hero">
          <div className="container">
            <Link className="back-link" to="/">
              <SafeIcon icon={FiArrowLeft} />
              Back to curriculum
            </Link>

            <div className="module-hero-grid">
              <div>
                <span className="eyebrow">Module {module.number}</span>
                <h1>{module.title}</h1>
                <p>{module.description}</p>
              </div>

              <div className="module-progress-card">
                <span>Module progress</span>
                <strong>{moduleProgress}%</strong>
                <div className="progress-track">
                  <span style={{width: `${moduleProgress}%`}} />
                </div>
                <small>
                  {completedCount} of {module.lessons.length} lessons complete
                </small>
              </div>
            </div>
          </div>
        </section>

        <section className="lesson-section">
          <div className="container">
            <div className="lesson-heading">
              <h2>Lessons in this module</h2>
              <span>
                <SafeIcon icon={FiBookOpen} />
                Select a lesson to study
              </span>
            </div>

            <div className="lesson-list">
              {module.lessons.map((lesson,index)=> {
                const isCompleted=completedLessons.includes(lesson.id);

                return (
                  <motion.article
                    className={isCompleted ? 'lesson-card is-complete' : 'lesson-card'}
                    key={lesson.id}
                    initial={{opacity: 0,y: 14}}
                    animate={{opacity: 1,y: 0}}
                    transition={{delay: index * 0.08}}
                  >
                    <span className="lesson-number">
                      {String(index + 1).padStart(2,'0')}
                    </span>

                    <div className="lesson-content">
                      <Link
                        to={`/lesson/${module.id}/${lesson.id}`}
                        className="lesson-title-link"
                      >
                        <h3 style={{display: 'inline-flex',alignItems: 'center',gap: '7px'}}>
                          {lesson.title}
                          <SafeIcon icon={FiChevronRight} />
                        </h3>
                      </Link>

                      <p>{lesson.description}</p>

                      <span className="read-time">
                        <SafeIcon icon={FiClock} />
                        {lesson.readTime} min read
                      </span>
                    </div>

                    <div className="lesson-actions">
                      <Link
                        className="study-lesson-link"
                        to={`/lesson/${module.id}/${lesson.id}`}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '7px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <span>Study lesson</span>
                        <SafeIcon icon={FiChevronRight} />
                      </Link>

                      <button
                        className="complete-button"
                        onClick={()=> onToggleLesson(lesson.id)}
                        aria-pressed={isCompleted}
                      >
                        <SafeIcon icon={FiCheck} />
                        {isCompleted ? 'Completed' : 'Mark complete'}
                      </button>
                    </div>
                  </motion.article>
                );
              })}
            </div>
          </div>
          <div className="container" style={{ margin: '2rem auto' }}>
          <ESYOHWidgets widgetId="940985" />
        </div>
        </section>
      </main>
    </>
  );
}

export default ModuleView;